import * as React from 'react';
import { tk, Typography, SpaceBetween, Accordion, Collapsible, CollapsibleTrigger } from '@sunwebgroup/ui-components';
import { useIntl } from '@/intl';
import { styled } from 'styled-components';

const Wrapper = styled(SpaceBetween)`
  margin-bottom: ${tk('spacing_5xl')};
`;
const ItemText = styled(Typography)`
  color: ${tk('color_semantic_text')};
}`;

const FaqItem = styled(Accordion.Item)`
  padding: ${tk('spacing_none')};
  ${CollapsibleTrigger} {
    padding: ${tk('spacing_sm')} ${tk('spacing_none')};
  }
  ${Collapsible} {
    padding-top: ${tk('spacing_none')};
    padding-bottom: ${tk('spacing_sm')};

    @media ${tk('mq_tablet')} {
      padding-right: ${tk('spacing_md')};
    }
  }
`;

export function Faq() {
  const intl = useIntl();

  const items = [...Array(4)].map((_, index) => {
    const itemIndex = index + 1;
    return (
      <FaqItem key={itemIndex} title={intl.formatMessage({ id: `checkout_steps_faq_${itemIndex}_title` })}>
        <ItemText
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: `checkout_steps_faq_${itemIndex}_description` }),
          }}
        />
      </FaqItem>
    );
  });

  return (
    <Wrapper direction="y" spacing={tk('spacing_md')}>
      <Typography $variant="body-md-bold"> {intl.formatMessage({ id: 'checkout_steps_faq_title' })}</Typography>
      <Accordion.Root>{items}</Accordion.Root>
    </Wrapper>
  );
}
